// Curated country list for signup. Arabic-speaking countries first, then common others.
export const SIGNUP_COUNTRIES: Array<{ code: string; en: string; ar: string }> = [
  { code: "SA", en: "Saudi Arabia", ar: "السعودية" },
  { code: "AE", en: "United Arab Emirates", ar: "الإمارات" },
  { code: "EG", en: "Egypt", ar: "مصر" },
  { code: "JO", en: "Jordan", ar: "الأردن" },
  { code: "KW", en: "Kuwait", ar: "الكويت" },
  { code: "QA", en: "Qatar", ar: "قطر" },
  { code: "BH", en: "Bahrain", ar: "البحرين" },
  { code: "OM", en: "Oman", ar: "عُمان" },
  { code: "LB", en: "Lebanon", ar: "لبنان" },
  { code: "PS", en: "Palestine", ar: "فلسطين" },
  { code: "SY", en: "Syria", ar: "سوريا" },
  { code: "IQ", en: "Iraq", ar: "العراق" },
  { code: "YE", en: "Yemen", ar: "اليمن" },
  { code: "MA", en: "Morocco", ar: "المغرب" },
  { code: "DZ", en: "Algeria", ar: "الجزائر" },
  { code: "TN", en: "Tunisia", ar: "تونس" },
  { code: "LY", en: "Libya", ar: "ليبيا" },
  { code: "SD", en: "Sudan", ar: "السودان" },
  { code: "TR", en: "Türkiye", ar: "تركيا" },
  { code: "US", en: "United States", ar: "الولايات المتحدة" },
  { code: "CA", en: "Canada", ar: "كندا" },
  { code: "GB", en: "United Kingdom", ar: "المملكة المتحدة" },
  { code: "DE", en: "Germany", ar: "ألمانيا" },
  { code: "FR", en: "France", ar: "فرنسا" },
  { code: "ES", en: "Spain", ar: "إسبانيا" },
  { code: "IT", en: "Italy", ar: "إيطاليا" },
  { code: "NL", en: "Netherlands", ar: "هولندا" },
  { code: "SE", en: "Sweden", ar: "السويد" },
  { code: "AU", en: "Australia", ar: "أستراليا" },
  { code: "MY", en: "Malaysia", ar: "ماليزيا" },
  { code: "ID", en: "Indonesia", ar: "إندونيسيا" },
  { code: "PK", en: "Pakistan", ar: "باكستان" },
  { code: "IN", en: "India", ar: "الهند" },
  { code: "OTHER", en: "Other", ar: "أخرى" },
];
